export default __webpack_public_path__ + "images/4G.265880a.png";